export default __webpack_public_path__ + "static/media/kaapi-4.ce8a81bc.png";